import { render, staticRenderFns } from "./HeaderPageInformation.vue?vue&type=template&id=4e2ec152&scoped=true&"
import script from "./HeaderPageInformation.vue?vue&type=script&lang=js&"
export * from "./HeaderPageInformation.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPageInformation.vue?vue&type=style&index=0&id=4e2ec152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2ec152",
  null
  
)

export default component.exports